import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { useEffect, useRef, useState } from "react";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { CharacterPartType } from "../../../dto/CharacterPartDTO";
import PiScrollArea from "../../../components/PiScrollArea";
export default function CharacterPartFilterDropdown(props: {
  selected: CharacterPartType;
  onChange: (type: CharacterPartType) => void;
}) {
  const { selected, onChange } = { ...props };
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef<HTMLDivElement | null>(null);
  const [width, setWidth] = useState<number>(1000);
  useEffect(() => {
    if (ref.current) {
      var w = ref.current?.offsetWidth.toString() + "px";
      setWidth(ref.current?.offsetWidth);
    }
  }, [ref.current?.offsetWidth]);

  const map = Object.keys(CharacterPartType)
    .filter((key) => isNaN(Number(key)))
    .map((type) => {
      return (
        <DropdownMenu.Item
          className={
            "flex-1 h-[42px] rounded-[5px] bg-creator-primary-background text-creator-text text-interaction-base cursor-pointer hover:bg-interaction-primary-selected flex mx-[6px] px-[8px] border-none" +
            " outline-none font-medium"
          }
          onClick={() =>
            onChange(CharacterPartType[type as keyof typeof CharacterPartType])
          }
        >
          <div className={"my-auto truncate"}>{type}</div>
        </DropdownMenu.Item>
      );
    });

  return (
    <div ref={ref} className="h-[36px]">
      <DropdownMenu.Root onOpenChange={setIsOpen} modal={false}>
        <DropdownMenu.Trigger className="w-full focus:outline-none">
          <div className="w-[100%] h-[36px] border-2 border-solid border-creator-primary rounded-[28px] flex items-center justify-center px-[12px] hover:bg-creator-primary-washed">
            <div className="w-[32px] text-creator-primary ">
              <FilterAltOutlinedIcon />
            </div>
            <div className="flex-1 justify-center align-middle text-creator-primary pr-[32px] ">
              {selected !== CharacterPartType.None
                ? CharacterPartType[selected]
                : "Choose Filter"}
            </div>
          </div>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content
          className={
            "py-[6px] gap-[6px] z-40 bg-creator-primary-background shadow-2xl border-2 border-interaction-primary-washed rounded-[10px] transform" +
            " -translate-y-0"
          }
          style={{ width: width + "px" }}
        >
          <PiScrollArea variant={"piCreatorBlue"} maxHeight={400}>
            {map}
          </PiScrollArea>
        </DropdownMenu.Content>
      </DropdownMenu.Root>
    </div>
  );
}
